import $ from "jquery";

export const scrollToTop = () => {
  const btns = $(".js-scroll-to-top");

  btns.on("click", function () {
    $("html, body").animate({ scrollTop: 0 });
  });
};
